import React from 'react'
import axios from '~/data/http/axios'
import classnames from 'classnames'
import Avatar from '~/Common-Objects/Avatar/Avatar'
import Button from '~/Common-Objects/UI/Forms/Button/Button'
import Icons from '~/Common-Objects/UI/Icons/index'
import LoadingIcons from '~/Common-Objects/LoadingIcons/loadingIcon1'
import TextInput from '~/Common-Objects/UI/Forms/TextInput/TextInput'
import { connect } from 'react-redux'
import i18n from '~/i18n'
import * as user from '~/data/actions/userActions' //now we can use user actions here

@connect((store) => {
    return {
        user: store.user,
        browser: store.browser,
        accountMaster: store.accountMaster,
        siteMaster: store.siteMaster,
        permissionStore: store.permission
    }
})
export default class banner extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            loading: true,
            createAccount: false,
            companyName: '',
            switchError: '',
            inputErrors: {
                companyName: ''
            }
        }
        this.createNewAccount = this.createNewAccount.bind(this)
        this.changeAccount = this.changeAccount.bind(this)
    }

    componentDidUpdate(prevProps) {
        if (prevProps.loadedAccounts === false && this.props.loadedAccounts === true) {
            this.setState({ loading: false })
        }
    }

    // resolves with an error message if the switch failed, otherwise null
    async changeAccount(companyId) {
        this.setState({ loading: true, switchError: '' })
        if (this.props.onChangeAccount) this.props.onChangeAccount(true)
        try {
            await this.props.dispatch(user.changeAccounts(companyId))
            return null
        } catch (err) {
            if (this.props.onChangeAccount) this.props.onChangeAccount(false)
            const message = (err && err.data && err.data.error) || i18n.t('nav:switchCompanyError')
            this.setState({ loading: false, switchError: message })
            return message
        }
    }

    async createNewAccount(e) {
        e.preventDefault()
        this.setState({ loading: true })

        var companyName = this.state.companyName
        var inputErrors = this.state.inputErrors
        inputErrors.companyName = ''

        if (companyName.length < 3) {
            inputErrors.companyName = i18n.t('nav:addCompany.error')
            this.setState({ inputErrors: inputErrors, loading: false })
            return
        }

        try {
            var data = { accountName: companyName }
            let newAcc = await axios.post('/accountMaster', data)
            // the create form is still on screen, so surface a failed switch here
            const switchError = await this.changeAccount(newAcc.data.AccountMaster.id)
            if (switchError) {
                inputErrors.companyName = switchError
                this.setState({ inputErrors: inputErrors, loading: false })
            }
        } catch (err) {
            inputErrors.companyName = err.data.error
            this.setState({ inputErrors: inputErrors, loading: false })
        }
    }

    handleTransitionEnd() {
        if (this.props.isOpen === false && this.state.createAccount === true) {
            this.setState({ createAccount: false })
        }
    }

    render() {
        var disableRegistration = false
        if (this.props.siteMaster && this.props.siteMaster.disableRegistration) {
            disableRegistration = true
            if (this.props.user.userData.isAgencyAdmin) {
                disableRegistration = false
            }
        }

        const classes = classnames('companySwitcher', this.props.className, {
            open: this.props.isOpen
        })

        const accountClasses = classnames('accounts', {
            open: this.state.createAccount === false
        })

        const createCompanyFormClasses = classnames('create-company-form', {
            open: this.state.createAccount
        })

        return (
            <div className={classes} onTransitionEnd={() => this.handleTransitionEnd()}>
                <div className={accountClasses}>
                    <div className='active-account'>
                        <div className='company'>
                            <Avatar src={this.props.activeAccount.companyLogo} />
                            <span className='name'>{this.props.activeAccount.accountName}</span>
                            <Icons icon='tick' />
                        </div>

                        <hr className='light-hr' />
                    </div>

                    {this.state.loading ? (
                        <LoadingIcons icon='2' />
                    ) : (
                        <>
                            {!!this.state.switchError && <div className='warning-holder'>{this.state.switchError}</div>}

                            {!this.props.accounts.length && (
                                <div className='warning-holder'>
                                    You don't belong to any other companies in {this.props.siteMaster.siteName}
                                </div>
                            )}

                            {this.props.accounts.length > 0 && (
                                <ul className='accounts-list fauxList'>
                                    {this.props.accounts.map((theAccount) => {
                                        return (
                                            <li key={theAccount.id}>
                                                <button
                                                    className='company'
                                                    onClick={() => {
                                                        this.changeAccount(theAccount.id)
                                                    }}
                                                >
                                                    <Avatar src={theAccount.companyLogo} />
                                                    <span className='name'>{theAccount.name}</span>
                                                </button>
                                            </li>
                                        )
                                    })}
                                </ul>
                            )}
                        </>
                    )}

                    {disableRegistration == false && (
                        <div className='add-new-company-button-wrapper'>
                            <Button
                                className='button-fullwidth outline'
                                iconLeft={<Icons icon='plus' />}
                                onClick={() => this.setState({ createAccount: true })}
                            >
                                {i18n.t('nav:addNewCompany')}
                            </Button>
                        </div>
                    )}
                </div>

                <form className={createCompanyFormClasses} onSubmit={this.createNewAccount}>
                    {this.state.loading ? (
                        <LoadingIcons icon='2' />
                    ) : (
                        <>
                            <p className='mar-b25'>{i18n.t('nav:addCompany.description')}</p>

                            <TextInput
                                outerClassName='mar-b15'
                                label={i18n.t('nav:addCompany.label')}
                                focus={true}
                                type='text'
                                placeholder={i18n.t('nav:addCompany.placeholder')}
                                name='companyName'
                                error={this.state.inputErrors.companyName}
                                value={this.state.companyName}
                                onChange={(ev) => {
                                    this.setState({ companyName: ev.target.value })
                                }}
                            />

                            <Button
                                type='submit'
                                className='button-primary button-fullwidth'
                                iconRight={<Icons icon='arrowRight' />}
                            >
                                Create Company
                            </Button>
                        </>
                    )}
                </form>
            </div>
        )
    }
}
